import React, { useState, useEffect } from "react";
import { Row, Button, Modal } from "antd";
import { useQuill } from "react-quilljs";
import { EditOutlined, CloseOutlined } from "@ant-design/icons";
import "quill/dist/quill.snow.css";

const style = {
  box: {
    border: "1px solid lightgrey",
    borderRadius: "5px",
    background: "#F2F3FF",
    padding: "10px",
    paddingBottom: "12px",
    marginBottom: "10px",
    width: "max-content",
    textAlign: "center",
    borderColor: "#3e79f7",
    justifyContent: "center",
  },
  modalDesc: {
    background: "#e9e9e9",
    padding: "10px",
  },
};

export const Docs = ({ title, value, onChange, hideButton = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { quill, quillRef } = useQuill();

  useEffect(() => {
    if (quill) {
      quill.clipboard.dangerouslyPasteHTML(value);
    }
  }, [quill]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    onChange(quill.root.innerHTML);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    if (quill) {
      quill.clipboard.dangerouslyPasteHTML(value);
    }
    setIsModalOpen(false);
  };

  return (
    <>
      <Row style={style.box}>
        <h4
          style={{
            paddingTop: "10px",
            paddingRight: "10px",
          }}
        >
          {title}
        </h4>
        {!hideButton && (
          <Button
            type="primary"
            style={{ width: "100px", backgroundColor: "#8D96FF" }}
            icon={<EditOutlined />}
            onClick={showModal}
          >
            Edit
          </Button>
        )}
      </Row>
      <Modal
        title={title}
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Save"
        cancelText="Discard Changes"
        width={900}
      >
        <div>
          <p>Current version: 3/23/2023</p>
          <Row style={style.modalDesc}>
            Our platform keeps track of all previous versions of content. You
            can access any of them by selecting from the list.
          </Row>
          <div>
            <div ref={quillRef} />
          </div>
        </div>
      </Modal>
    </>
  );
};
